<!-- 时间的模板 -->
<template>
  <div class="EventTemplate" id="EventTemplateWrap">
    <!-- <div class="EventTemplate" v-if="false"> -->
    <!-- 表格主体部分 -->
    <div class="TemplateName">{{templateName}}
        <el-popover
          placement="bottom"
          width="400"
          popper-class='templatePopover'
          v-model="visible"
          >
          <div class="title">
            <div><span class="checkout">*</span> {{$t('lang.rename')}}</div>
            <div> <i class="el-icon-close" @click="visible=false"></i></div>
          </div>
          <div class="templateName"><el-input v-model="templateName"  @input="templateNameIput"></el-input></div>
          <i class="el-icon-arrow-down" slot="reference" ></i>
        </el-popover>
     </div>
    <table class="TableBady" v-if="TemplateType == 'schedule'" cellpadding="0" cellspacing="0">
      <!-- 头部周几 标题 -->
      <thead>
        <tr>
          <td>
            <div class="TemplateTopTime">
              <table style="width: 99.8%">
                <tr>
                  <!-- <th class="kongbai">Zoom</th> -->
                  <th class="kongbai1" style="width: 5%">{{$t('lang.time')}}</th>
                  <th class="TopTitle" v-for="(item, index) in WeekTitle" :key="index" :data-day="index" :style="{
                      width: WeekTitle.length == 1 ? '91.7%' : '13.1%',
                    }">
                    {{ item }}
                  </th>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </thead>
      <!-- 表格主体内容 -->
      <tbody class="TemplateWrapHeight">
        <tr style="height: 100%">
          <td style="height: 100%">
            <div class="TemplateWrap">
              <div class="EventAndTime">
                <div class="TimeWrap">
                  <table class="TableBady">
                    <tbody>
                      <!-- 事件存放地方 -->
                      <tr class="EventWrap">
                        <!-- <td style="width: 5%"></td> -->
                        <td style="width: 5%"></td>
                        <td class="WeekEvent" v-for="(item, index) in WeekTitle" :key="index" :style="{
                            width: WeekTitle.length == 1 ? '91.7%' : '13.1%',
                          }">
                          <div v-for="(item1, index1) in EventMessageList" :key="index1">
                            <div class="EventStyle" v-if="index == item1.someday" :style="item1.style" :data-device="JSON.stringify(item1)" :data-index="index1" draggable="true" @click="ClickPitchOn(0, item1, index1, $event)">
                              <p class="EventTitle">
                                {{ millisecondTime(item1.startTime) + "-" + millisecondTime(item1.endTime) + " " + item1.title }}
                              </p>
                              <div class="ScteListWrap" v-if="item1.segmentVos && item1.segmentVos.length>0">
                                <div v-for="(item, index) in item1.segmentVos" :key="index">
                                  <div v-if="item.segmentId != 1 && item.segmentId != 9 && item.segmentId != 13" class="ScteWrap" :style="computedStyle(item, item1)">
                                  </div>
                                </div>
                              </div>
                              <div class="ErrMessage" v-if="item1.errorMessage">
                                <p>{{item1.errorMessage}}</p>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- 时间盒子 -->
                      <tr id="dragTimeWrap">
                        <!-- <td style="width: 5%"> -->
                          <!-- Zoom放大功能 -->
                          <!-- <tr v-for="item in 48" :key="item">
                            <td class="ZoomCenter">
                              <p @click="ZoomTimeHorizon(item)">Zoom+</p>
                            </td>
                          </tr> -->
                        <!-- </td> -->
                        <!-- 侧边 -->
                        <td style="width: 5%">
                          <tr v-for="item in 48" :key="item">
                            <td class="leftTime">{{ broadsideTime(item) }}</td>
                          </tr>
                        </td>
                        <!-- 时间块 -->
                        <td v-for="(item, index) in WeekTitle" :key="index" :data-day="index" :style="{
                            width: WeekTitle.length == 1 ? '91.7%' : '13.1%',
                          }">
                          <div v-for="item1 in 48" :key="item1">
                            <!-- index * 24 * 60 * 1000 + item1 * 30 * 60 * 1000 -->
                            <div :class="[
                                'TimePatch',
                                {
                                  SelectTimePatch:
                                    SelectCreateIndex == item1 + index * 48,
                                },
                              ]" @click="
                                SelectCreate(
                                  item1 + index * 48,
                                  index * 24 * 60 * 60 * 1000 +
                                    (item1 - 1) * 30 * 60 * 1000
                                )
                              " :data-time="
                                index * 24 * 60 * 60 * 1000 +
                                  (item1 - 1) * 30 * 60 * 1000
                              ">
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 下面的操作 -->
    <div class="operation" v-if="TemplateType == 'schedule'">
      <div class="cancel">
        <el-button type="info" size="medium" @click="CancelTemplate">{{ $t('lang.cancel') }}</el-button>
      </div>
      <div class="save">
        <el-button :disabled="CloneDisabled.Template" type="success" size="medium" @click="SaveAsTemplate"  :loading='SaveAsTemplateLoading'>{{ $t('lang.saveAs') }}</el-button>
      </div>
      <div class="save">
        <el-button :disabled="CloneDisabled.Template" type="success" size="medium" @click="SaveTemplate" :loading='SaveTemplateLoading'>{{ $t('lang.save') }}</el-button>
      </div>
    </div>
    <!-- zoom放大模块 -->
    <div class="ZoomShade" v-if="IsZoomTemplate">
      <template-zoom :TemplateSchedule="WeekTitle" :TemplateBodyMessage="TemplateBodyMessage" :fixedDevice="fixedDevice" :EventMessageList="EventMessageList" :ZoomTime="ZoomTime" :dynamicDevice="dynamicDevice" @closeZoom="closeZoom" @ClickEvent="ClickPitchOn"></template-zoom>
    </div>
    <!-- 弹出框 -->
    <div class="Pop" v-if="popUpBox">
      <!-- 创建框 -->
      <template-popup
        :picthOnEvent="picthOnEvent"
        :EventMotion="EventMotion"
        :fixedDevice="fixedDevice"
        :BoxPosition="BoxPosition"
        :PreviousAction="PreviousAction"
        :UndoActionPro="UndoActionPro"
        :SettingMessage="SettingMessage"
        @closeBooking="closeBooking"
        @saveBooking="saveBooking"
        @createBooking="createBooking"
        @deleteBooking="deleteBooking"
      ></template-popup>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import DragMethod from '@/assets/js/common/drag'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import TemplateZoom from './TemplateZoom.vue'
import TemplatePopup from './TemplatePopup.vue'
import toTips from '@/assets/js/toTipsObj'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import UndoAction from '@/assets/js/common/UndoAction.js'
export default {
  props: {
    // 查询模板的信息
    TemplateBodyMessage: {
      type: Object,
      default: () => ({})
    },
    // 一周标题
    WeekTitle: {
      type: Array,
      default: () => ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    // R的信息
    fixedDevice: Object,
    dynamicDevice: Object
  },
  data () {
    return {
      // 模板的类型
      TemplateType: 'schedule',
      //   模板数据
      EventMessageList: [],
      //   一天的时间
      DayTime: 24 * 60 * 60 * 1000,
      // 每毫秒高度
      // secondHeight: 7201 / (24 * 60 * 60 * 1000),
      secondHeight: 5 / (60 * 1000),
      //   绑定推拽
      BindDragMethod: '',
      // 选择放大的时间范围
      ZoomTime: {
        time: '12:0',
        type: 'AM',
        startTime: 0
      },
      // 是否放大
      IsZoomTemplate: false,
      // 选中的事件
      picthOnEvent: {},
      // 选中事件的下标
      picthOnEventI: -1,
      // 是否显示弹出框
      popUpBox: false,
      // 对事件的几种操作 // 0 展示 1编辑 2创建
      EventMotion: 0,
      // 弹出框的位置
      BoxPosition: {
        // 创建框的位置
        left: 0,
        top: 0,
        triangle: false,
        bottom: false
      },
      // 选择创建的下标
      SelectCreateIndex: -1,
      // 获取全部事件分页
      AllEventPage: 0,
      // 选择当天的时间段
      TimeQuantum: 0,
      // 时间格式
      TimeFormat: 0,
      // 另存为修改name弹框
      saveAsShow: false,
      visible: false,
      templateName: JSON.parse(JSON.stringify(this.TemplateBodyMessage.name)),
      SaveAsTemplateLoading: false,
      SaveTemplateLoading: false,
      UndoActionPro: null,
      PreviousAction: {},
      SettingMessage: {}
    }
  },
  components: {
    TemplateZoom,
    TemplatePopup
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 多选选中的文件夹
      PitchOnFileList: (state) => state.playout.PitchOnFileList,
      State: (state) => state
    })
  },
  created () {
    // 获取模板的全部事件
    this.getTemplateEvent()
    // 判断是schedule还是format
    if (this.WeekTitle.length == 0) {
      this.TemplateType = 'format'
      this.IsZoomTemplate = true
      this.ZoomTime = {
        time: '00:0',
        type: '',
        startTime: 0
      }
    }
  },
  watch: {
    //   监听列表变化
    EventMessageList () {
      this.computeEvent()
      this.registerDrag()
    },
    // 监听zoom放大
    IsZoomTemplate () {
      this.popUpBox = false
    },
    // 监听弹窗
    popUpBox (content) {
      if (content) {
        // $('.EventTemplate .TemplateWrap').css('overflow-y', 'hidden')
      } else {
        // $('.EventTemplate .TemplateWrap').css('overflow-y', 'scroll')
      }
    },
    // 行为同步
    'State.BehaviorChange' (data) {
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'userEditUnLock' && data.type == 2) {
        const userId = localStorage.getItem('userId')
        if (userId == data.userId) {
          NotManyEdit.ReleaseHint(Outil.getProgramReceiver('ownerEmail'), this.CancelTemplate)
        }
      }
    }
  },
  mounted () {
    window.addEventListener('unload', this.EditSend)
    this.$nextTick(() => {
      this.bindingDrag()
    })
    // 左边列表发生变化
    Bus.$on('leftListUpdate', this.registerDrag)
    this.EditSend('add')
    const TimeFormat = Outil.getDateTimeFormat()
    this.TimeFormat = TimeFormat.broadcastTimeFormat
    this.TimeQuantum = Outil.getProgramReceiver('broadcastDay')
    if (this.TemplateBodyMessage.absoluteTime != null && this.TemplateBodyMessage.absoluteTime != undefined) {
      this.TimeQuantum = this.TemplateBodyMessage.absoluteTime
    }
    const UndoParam = {
      MaxStep: 5,
      executeCommand: this.Undo
    }
    this.UndoActionPro = new UndoAction(UndoParam)
    this.UndoActionPro.init()
    this.$store.state.playout.UndoCurrentType = 'ScheduleTemplate'
    Bus.$on('closeTemplate', (id) => {
      if (this.TemplateBodyMessage.id == id) {
        this.CancelTemplate()
      }
    })
  },
  methods: {
    // 接收撤回消息
    Undo (data) {
      let item = ''
      if (this.popUpBox && data.popUpBox != false) {
        if (this.PreviousAction && this.PreviousAction.eventDetail == data.eventDetail) {
          this.PreviousAction = null
          this.$nextTick(() => {
            this.PreviousAction = data
          })
        } else {
          this.PreviousAction = data
        }
        return
      }
      // 显示弹出框
      if (data.eventDetail) {
        this.PreviousAction = data
      }
      Object.keys(data).forEach((key) => {
        try {
          item = JSON.parse(data[key])
        } catch (error) {}
        if (typeof item == 'object') {
          this._data[key] = item
        } else {
          this._data[key] = data[key]
        }
      })
    },
    // 发送行为消息
    PushUndo (type) {
      const PreviousAction = {}
      const key = (type == 'input' || type == 'inputEnd') ? type : ''
      // PreviousAction.CompileType = this.CompileType
      PreviousAction.SelectCreateIndex = this.SelectCreateIndex
      PreviousAction.EventMotion = this.EventMotion
      PreviousAction.picthOnEventI = this.picthOnEventI
      PreviousAction.popUpBox = this.popUpBox
      PreviousAction.EventMessageList = JSON.stringify(this.EventMessageList)
      PreviousAction.picthOnEvent = JSON.stringify(this.subeventList)
      PreviousAction.BoxPosition = JSON.stringify(this.BoxPosition)
      if (type == 'clearUndo') {
        this.UndoActionPro.clearUndo(PreviousAction)
      } else {
        this.UndoActionPro.pushUndo(PreviousAction, key)
      }
      this.PreviousAction = {}
      this.SettingMessage = {
        ...PreviousAction
      }
    },
    templateNameIput (val) {
      if (val == '') {
        this.$message(this.$t('lang.ScheduleEmpty'))
      }
    },
    // 在编辑add、取消编辑close,浏览器关闭 空
    EditSend (type) {
      const param = {
        logicId: this.TemplateBodyMessage.id,
        type: 2
      }
      if (type == 'add') {
        param.pid = this.$BehaviorSyns.getProgramId()
        param.name = this.TemplateBodyMessage.name
        NotManyEdit.AddEdit(param)
      } else if (type == 'close') {
        NotManyEdit.QuitEdit(param)
      } else {
        NotManyEdit.CloseQuitEdit(param)
      }
    },
    // 计算样式
    computedStyle (item, parentItem) {
      const ScteTop = Math.floor((item.timingIn - parentItem.startTime) * this.secondHeight)
      const ScteHeight = Math.floor((item.timingOut - item.timingIn) * this.secondHeight)
      const style = {
        height: `${ScteHeight}px`,
        top: `${ScteTop}px`
      }
      if (item.segmentId == 5) {
        style['background-color'] = '#388BE5'
      } else if (item.segmentId == 10) {
        style['background-color'] = '#DA6F17'
      }
      return style
    },
    //   左边列表变化重新绑定拖拽事件
    registerDrag () {
      this.$nextTick(() => {
        this.bindingDrag()
      })
    },
    // 点击选择创建事件
    SelectCreate (index, startTime) {
      this.SelectCreateIndex = index
      this.ClickPitchOn(1, {
        startTime,
        endTime: startTime + 30 * 60 * 1000
      })
    },
    // 点击选中的事件
    ClickPitchOn (type, item, index, jsEvent) {
      const popUpBox = this.popUpBox
      this.popUpBox = false
      if (popUpBox && !this.popUpBox) {
        // 推送操作
        this.PushUndo()
      }
      this.SetFramePosition(jsEvent)
      if (type) {
        this.EventMotion = 2
        this.picthOnEvent = {
          templateId: this.TemplateBodyMessage.id, // 必传
          bitrate: 5120,
          color: 'rgb(255, 192, 0)',
          delay: 2,
          description: '',
          rname: this.fixedDevice.name,
          reporter: '',
          rpeerid: '', // 必传
          scheduleType: 'live', // 必传
          scteId: '',
          title: '', // 必传
          tname: '',
          tpeerid: '', // 必传
          ttype: 'Video', // 必传
          turl: null,
          startTime: item.startTime, // 必传
          endTime: item.endTime // 必传
        }
      } else {
        this.EventMotion = 0
        this.picthOnEvent = item
        this.picthOnEventI = index
      }

      this.$nextTick(() => {
        this.popUpBox = true
        // 推送操作
        this.PushUndo()
      })
    },
    // 计算弹出框位置
    SetFramePosition (jsEvent) {
      const ClickEvent = jsEvent || window.event
      // 盒子距离上边左边距离
      const calendarLeft = document.getElementsByClassName('calendarLeft')[0].clientWidth
      const calendarRight = document.getElementById('EventTemplateWrap')
      const calendarRightTop = calendarRight.getBoundingClientRect().top
      const FramePosition = {
        top: ClickEvent.clientY - calendarRightTop,
        left: ClickEvent.clientX - calendarLeft,
        bottom:
          calendarRight.clientHeight - ClickEvent.clientY + calendarRightTop,
        right: calendarRight.clientWidth - ClickEvent.clientX + calendarLeft
      }
      if (FramePosition.bottom >= 400 && FramePosition.right >= 700) {
        this.BoxPosition.top = FramePosition.top
        this.BoxPosition.left = FramePosition.left - 70
        this.BoxPosition.upward = true
        this.BoxPosition.aleft = true
      } else if (FramePosition.bottom < 400 && FramePosition.right >= 700) {
        this.BoxPosition.top = FramePosition.top
        this.BoxPosition.left = FramePosition.left - 70
        this.BoxPosition.upward = false
        this.BoxPosition.aleft = true
      } else if (FramePosition.bottom >= 400 && FramePosition.right < 700) {
        this.BoxPosition.top = FramePosition.top
        this.BoxPosition.left = FramePosition.left + 70
        this.BoxPosition.upward = true
        this.BoxPosition.aleft = false
      } else {
        this.BoxPosition.top = FramePosition.top
        this.BoxPosition.left = FramePosition.left + 70
        this.BoxPosition.upward = false
        this.BoxPosition.aleft = false
      }
      this.BoxPosition.top = this.BoxPosition.top
      this.BoxPosition.left = this.BoxPosition.left
    },
    // 创建框的一系列操作
    closeBooking () {
      this.popUpBox = false
      this.SelectCreateIndex = -1
      // 推送操作
      this.PushUndo()
    },
    // 删除
    deleteBooking () {
      this.EventMessageList.splice(this.picthOnEventI, 1)
      this.popUpBox = false
      // 推送操作
      this.PushUndo()
    },
    // 保存
    saveBooking (createObject) {
      const TargetEvent = this.EventMessageList.splice(this.picthOnEventI, 1)
      //   判断是否与其他事件冲突
      const IsConflict = this.IsConflict(createObject)
      if (IsConflict) {
        this.EventMessageList.push(TargetEvent[0])
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      } else {
        this.EventMessageList.push(createObject)
      }
      this.popUpBox = false
      // 推送操作
      this.PushUndo()
    },
    // 创建
    createBooking (createObject) {
      //   判断是否与其他事件冲突
      const IsConflict = this.IsConflict(createObject)
      if (IsConflict) {
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      } else {
        this.EventMessageList.push(createObject)
      }
      this.popUpBox = false
      this.SelectCreateIndex = -1
      // 推送操作
      this.PushUndo()
    },
    //   绑定推拽事件
    bindingDrag () {
      if (this.WeekTitle.length !== 0) {
        this.BindDragMethod = new DragMethod()
        this.BindDragMethod.create({
          // 拖到的区域
          dropZones: document.getElementById('dragTimeWrap'),
          // 被拖动的元素
          from: [
            document.querySelectorAll('.draggable_box .draggable_item'),
            document.querySelectorAll('.TemplateWrap .EventWrap .EventStyle')
          ],
          dropEnd: (e) => {
            // e 落下的盒子
            //   盒子初始时间
            const BoxStartTime = Number(e.target.dataset.time)
            //   被拖拽元素数据
            const TargetEvent = JSON.parse(
              this.BindDragMethod.dragElement.dataset.device
            )
            const templateDetailStatus = this.BindDragMethod.dragElement.dataset.template
            const programTemplate = this.BindDragMethod.dragElement.dataset.programtemplate

            if (templateDetailStatus) {
              // this.$message.info(this.$t('lang.forbidTemplate'))
              return
            }
            if (!isNaN(BoxStartTime) && TargetEvent) {
              if (programTemplate) {
                this.DragTemplateCreateEvent(
                  BoxStartTime,
                  BoxStartTime + 30 * 60 * 1000,
                  TargetEvent
                )
              } else {
                //  判断是重新创建还是修改  模板id又值则为修改
                if (TargetEvent.templateId) {
                  //   修改事件
                  this.DragUpdateEvent(
                    BoxStartTime,
                    BoxStartTime + 30 * 60 * 1000,
                    TargetEvent,
                    this.BindDragMethod.dragElement.dataset.index
                  )
                } else {
                  //   创建事件
                  this.DragCreateEvent(
                    BoxStartTime,
                    BoxStartTime + 30 * 60 * 1000,
                    TargetEvent
                  )
                }
              }
            }
          }
        })
      }
    },
    //   侧边的时间
    broadsideTime (index) {
      let type = ''
      let hour = 0
      if (!(index % 2)) {
        return ''
      }
      hour = index - 2 > 0 ? index : 0
      hour = Math.floor((hour) / 2)
      hour = hour + this.TimeQuantum > 23 ? hour + this.TimeQuantum - 24 : hour + this.TimeQuantum
      if (this.TimeFormat) {
        type = hour < 11 ? 'AM' : 'PM'
      } else {
        if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
      }
      return `${hour}${type}`
    },
    // 选择放大时间范围
    ZoomTimeHorizon (index) {
      const indexOld = index
      let hour,
        type
      index = Math.ceil(index / 2)
      if (index == 1) {
        hour = 12
        type = 'AM'
      } else if (index == 13) {
        hour = 12
        type = 'PM'
      } else if (index <= 12) {
        hour = index - 1
        type = 'AM'
      } else {
        hour = index - 13
        type = 'PM'
      }
      if (!(indexOld % 2)) {
        this.ZoomTime.time = `${hour}:30`
        this.ZoomTime.type = type
      } else {
        this.ZoomTime.time = `${hour}:0`
        this.ZoomTime.type = type
      }
      this.ZoomTime.startTime = (indexOld - 1) * 30 * 60 * 1000
      this.IsZoomTemplate = true
    },
    // 关闭放大
    closeZoom () {
      if (this.TemplateType == 'schedule') {
        this.IsZoomTemplate = false
        this.registerDrag()
      } else {
        this.IsZoomTemplate = false
        this.$emit('CancelTemplate')
      }
    },
    // 获取模板事件
    getTemplateEvent (id) {
      this.AllEventPage++
      this.axios
        .post(Outil.getUrl('/templateDetail/page'), {
          pageNum: this.AllEventPage,
          pageSize: 200,
          templateId: id || this.TemplateBodyMessage.id
        })
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            if (this.AllEventPage == 1) {
              this.EventMessageList = []
            }
            this.EventMessageList.push(...res.data.result.list)
            this.computeEvent()
            if (res.data.result && res.data.result.hasNextPage) {
              this.getTemplateEvent()
            } else {
              // 推送操作
              this.PushUndo()
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 计算事件所占高度以及所处位置
    computeEvent () {
      this.EventMessageList.map((item) => {
        if (!item.tpeerid) {
          item.color = 'rgb(255, 255, 255)'
        }
        // 哪一天
        const someday = Math.floor(item.startTime / this.DayTime)
        // 时间间隔
        const timeInterval = item.startTime - someday * this.DayTime
        // 事件时间长度
        const eventTimeLength = item.endTime - item.startTime
        const style = {
          width: this.WeekTitle.length == 1 ? '91.7%' : '13.1%',
          height: `${this.secondHeight * eventTimeLength}px`,
          position: 'absolute',
          top: `${this.secondHeight * timeInterval}px`,
          backgroundColor: item.color ? item.color : 'rgb(255, 192, 0)'
        }
        if (item.errorMessage) {
          style.backgroundColor = '#8A4B4B'
        }
        item.style = style
        item.someday = someday
        return item
      })
    },
    // 是否与原有事件冲突
    IsConflict (createObject) {
      return this.EventMessageList.some((item) => (
        (item.startTime >= createObject.startTime &&
          item.startTime < createObject.endTime) ||
        (item.endTime > createObject.startTime &&
          item.endTime <= createObject.endTime)
      ))
    },
    // 拖拽修改事件
    DragUpdateEvent (BoxStartTime, BoxEndTime, TargetEvent) {
      // 删除原本的事件
      this.EventMessageList.splice(
        this.BindDragMethod.dragElement.dataset.index,
        1
      )

      const LastTime = this.getLatelyEvent(BoxStartTime, BoxEndTime)

      //   判断最后一个事件结束时间在不在范围内
      if (LastTime >= BoxStartTime && LastTime <= BoxEndTime) {
        const createObject = this.createObject(TargetEvent, LastTime)

        //   判断是否与其他事件冲突
        const IsConflict = this.IsConflict(createObject)
        if (IsConflict) {
          this.EventMessageList.push(TargetEvent)
          this.$message.error(this.$t('lang.bookingRTimeconflict'))
        } else {
          this.EventMessageList.push(createObject)
        }
      } else if (LastTime > BoxEndTime) {
        this.EventMessageList.push(TargetEvent)
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      }
      // 推送操作
      this.PushUndo()
    },
    // 推拽创建事件
    DragCreateEvent (BoxStartTime, BoxEndTime, TargetEvent) {
      const LastTime = this.getLatelyEvent(BoxStartTime, BoxEndTime)
      //   判断最后一个事件结束时间在不在范围内
      if (LastTime >= BoxStartTime && LastTime < BoxEndTime) {
        if (this.PitchOnFileList[TargetEvent.id]) {
          this.batchAddEvent(LastTime)
        } else {
          this.AddEvent(TargetEvent, LastTime)
        }
      } else if (LastTime >= BoxEndTime) {
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      }
    },
    // 批量添加事件
    batchAddEvent (LastTime) {
      let ListStartTime = LastTime
      Object.keys(this.PitchOnFileList).some(key => {
        const createEndTime = this.AddEvent(this.PitchOnFileList[key], ListStartTime, 'batch')
        if (createEndTime) {
          ListStartTime = createEndTime
        }
        return !createEndTime
      })
      // 推送操作
      this.PushUndo()
    },
    // 添加事件
    AddEvent (TargetEvent, LastTime, type) {
      const createObject = this.createObject(TargetEvent, LastTime)
      //   判断是否与其他事件冲突
      const IsConflict = this.IsConflict(createObject)
      if (IsConflict) {
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      } else {
        const eventSegments = {
          ShowTimingIn: '',
          ShowTimingOut: '',
          accumulatedProgramTiming: 0,
          eventOperationType: null,
          fileId: null,
          fileName: '',
          segmentId: 1,
          segmentOrder: 0,
          sourceId: '',
          timingIn: createObject.startTime,
          timingOut: createObject.endTime
        }
        createObject.segmentVos = [eventSegments]
        this.EventMessageList.push(createObject)
        if (type != 'batch') {
          // 推送操作
          this.PushUndo()
        }
        return createObject.endTime
      }
    },
    // 拖拽模板创建事件
    DragTemplateCreateEvent (BoxStartTime, BoxEndTime, TargetEvent) {
      const LastTime = this.getLatelyEvent(BoxStartTime, BoxEndTime)
      //   判断最后一个事件结束时间在不在范围内
      if (LastTime >= BoxStartTime && LastTime < BoxEndTime) {
        this.axios.post(Outil.getUrl('/templateDetail/oneBlock'), {
          eventTemplateId: TargetEvent.id,
          startTime: LastTime,
          programId: this.$BehaviorSyns.getProgramId()
        })
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              const segmentVos = res.data.result.segmentVos
              if (segmentVos && segmentVos.length > 0) {
                segmentVos.forEach((item, index) => {
                  delete item.id
                  if (index == 0) {
                    item.timingIn = res.data.result.startTime
                    item.timingOut = item.accumulatedProgramTiming * 1000 + res.data.result.startTime
                  } else {
                    item.timingIn = segmentVos[index - 1].timingOut
                    item.timingOut = item.accumulatedProgramTiming * 1000 + res.data.result.startTime
                  }
                  // item.timingIn = res.data.result.startTime + item.timingIn * 1000
                  // item.timingOut = res.data.result.startTime + item.timingOut * 1000
                })
              }
              console.log(segmentVos)
              const createObject = res.data.result
              createObject.templateId = this.TemplateBodyMessage.id
              createObject.bitrate = '5120'
              createObject.delay = '2'
              //   判断是否与其他事件冲突
              const IsConflict = this.IsConflict(createObject)
              if (IsConflict) {
                this.$message.error(this.$t('lang.bookingRTimeconflict'))
              } else {
                this.EventMessageList.push(createObject)
              }
              // 推送操作
              this.PushUndo()
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      } else if (LastTime >= BoxEndTime) {
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      }
    },
    // 创建事件对象
    createObject (TargetEvent, LastTime) {
      let EventObject = {
        templateId: this.TemplateBodyMessage.id, // 必传
        bitrate: 5120,
        color: 'rgb(255, 192, 0)',
        delay: 2,
        description: '',
        reporter: '',
        rpeerid: '', // 必传
        scheduleType: 'live', // 必传
        scteId: '',
        title: '', // 必传
        tname: '',
        tpeerid: '', // 必传
        ttype: 'Video', // 必传
        turl: null,
        startTime: 0, // 必传
        endTime: 0 // 必传
      }
      // 编辑
      if (TargetEvent.templateId) {
        const Interval = TargetEvent.endTime - TargetEvent.startTime
        // 避免浅拷贝,影响之前数据
        EventObject = JSON.parse(JSON.stringify(TargetEvent))
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + Interval
        if (EventObject.segmentVos && EventObject.segmentVos.length > 0) {
          this.UpdateSegmentTime(EventObject.startTime - TargetEvent.startTime, EventObject)
        }
        // 创建
      } else if (['file', 'video', 'json', 'tvu'].includes(TargetEvent.type.toLowerCase())) {
        EventObject.rpeerid = this.fixedDevice.peerId
        EventObject.title = TargetEvent.name
        EventObject.tname = TargetEvent.name
        EventObject.tpeerid = TargetEvent.sourceId
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + Number(TargetEvent.videoTimes) * 1000
        EventObject.color =
          TargetEvent.setType == 'break'
            ? 'rgb(146, 72, 199)'
            : 'rgb(255, 192, 0)'
      } else {
        EventObject.rpeerid = this.fixedDevice.peerId
        EventObject.title = TargetEvent.name
        EventObject.tname = TargetEvent.name
        EventObject.tpeerid = TargetEvent.peerId
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + 30 * 60 * 1000
        EventObject.ttype = TargetEvent.type
      }
      return EventObject
    },
    // 更新子事件的时间
    UpdateSegmentTime (duration, EventObject) {
      EventObject.segmentVos.forEach((item) => {
        item.timingIn = item.timingIn + duration
        item.timingOut = item.timingOut + duration
      })
    },
    // 获取时间段内最近的一个事件的结束时间
    getLatelyEvent (boxStart, boxEnd) {
      let LastTime = boxStart
      this.EventMessageList.forEach((item) => {
        // 事件的开始或结束在时间段内的
        if (item.endTime >= boxStart && item.endTime <= boxEnd) {
          //   判断哪个最近
          if (LastTime < item.endTime) {
            LastTime = item.endTime
          }
        }
      })

      return LastTime
    },
    // 另存为模板
    SaveAsTemplate () {
      if (this.templateName == '') {
        this.$message(this.$t('lang.ScheduleEmpty'))
        return
      }
      const EventMessageList = JSON.parse(JSON.stringify(this.EventMessageList))
      EventMessageList.forEach((item) => {
        item.addSegments = item.segmentVos
        delete item.segmentVos
      })
      const params = {
        name: this.templateName,
        type: this.TemplateBodyMessage.type,
        scheduleType: this.TemplateBodyMessage.scheduleType,
        programId: this.$BehaviorSyns.getProgramId(),
        addTemplateDetailParams: EventMessageList
      }
      this.SaveAsTemplateLoading = true
      this.axios
        .post(Outil.getUrl('/template/templateSaveAs'), params)
        .then((res) => {
          this.SaveAsTemplateLoading = false
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.success'))
            this.AllEventPage = 0
            Bus.$emit('ScheduleTemplateUpdate')
            this.$emit('CancelTemplate')
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          this.SaveAsTemplateLoading = false
        })
    },
    // 保存模板
    SaveTemplate () {
      const EventMessageList = JSON.parse(JSON.stringify(this.EventMessageList))
      EventMessageList.forEach((item) => {
        const DayEnd = (item.someday + 1) * this.DayTime

        if (item.endTime > DayEnd) {
          item.endTime = DayEnd
        }
        item.addSegments = item.segmentVos
        delete item.segmentVos
        delete item.someday
        delete item.style
        delete item.userId
      })
      const params = {
        templateId: this.TemplateBodyMessage.id,
        templateName: this.templateName,
        addTemplateDetailParams: EventMessageList
      }
      this.SaveTemplateLoading = true
      this.axios
        .post(Outil.getUrl('/templateDetail/update'), params)
        .then((res) => {
          this.SaveTemplateLoading = false
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.success'))
            this.AllEventPage = 0
            Bus.$emit('ScheduleTemplateUpdate')
            this.$emit('CancelTemplate')
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          this.SaveTemplateLoading = false
        })
    },
    // 取消模板
    CancelTemplate () {
      this.$emit('CancelTemplate')
    },
    // 模板的毫秒转换时间
    millisecondTime (time) {
      const NewTime = time + this.TimeQuantum * 60 * 60 * 1000
      let type = ''
      let hour,
        minute,
        second
      hour = Math.floor((NewTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
      minute = Math.floor((NewTime % (60 * 60 * 1000)) / (60 * 1000))
      second = Math.floor((NewTime % (60 * 1000)) / 1000)
      if (this.TimeFormat) {
        hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
      } else {
        if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
      }
      minute = minute >= 0 && minute < 10 ? `0${minute}` : minute
      second = second >= 0 && second < 10 ? `0${second}` : second
      return `${hour}:${minute}:${second} ${type}`
    }
  },
  destroyed () {
    Bus.$off('leftListUpdate', this.registerDrag)
    this.EditSend('close')
    window.removeEventListener('unload', this.EditSend)
    this.UndoActionPro.stop()
    Bus.$off('closeTemplate')
  }
}
</script>

<style scoped lang="less">
.EventTemplate {
  background: #444444;
  width: 100%;
  position: relative;
  height: 100%;
  .TemplateName{
    padding-left: 5%;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    .el-icon-arrow-down{
      cursor: pointer;
    }
  }
  .TableBady {
    width: 100%;
    height: calc(100% - 107px);
  }
  .TemplateTopTime {
    height: 51px;
    th {
      border: 1px solid #252525;
    }
    .kongbai {
      width: 5%;
      height: 51px;
      text-align: center;
    }
    .kongbai1 {
      width: 2.7%;
      height: 51px;
      text-align: center;
    }
    .TopTitle {
      width: 13.1%;
      height: 51px;
      text-align: center;
    }
  }
  .TemplateWrapHeight{
    height: calc(100% - 51px);
  }
  .TemplateWrap {
    height: 100%;
    overflow-y: auto;
    .TimeWrap {
      position: relative;
      overflow: hidden;
      .ZoomCenter {
        width: 5%;
        height: 150px;
        border-left: 1px solid #252525;
        border-bottom: 1px solid #252525;
        p {
          width: fit-content;
          height: 20px;
          background: #252525;
          margin: 0 auto;
        }
      }
      .leftTime {
        width: 2.6%;
        height: 150px;
        border-left: 1px solid #252525;
        border-bottom: 1px solid #252525;
      }

      .TimePatch {
        height: 150px;
        border-left: 1px solid #252525;
        border-bottom: 1px solid #252525;
      }
      .SelectTimePatch {
        height: 150px;
        padding: 2px;
        background-image: -webkit-linear-gradient(
          -45deg,
          #10b467 25%,
          rgba(16, 180, 103, 0) 0,
          rgba(16, 180, 103, 0) 50%,
          #10b467 0,
          #10b467 75%,
          rgba(16, 180, 103, 0) 0,
          rgba(16, 180, 103, 0)
        );
        background-size: 10px 10px;
        -webkit-animation: antline-data-v-f26519bc 0.8s linear infinite;
        animation: antline-data-v-f26519bc 0.8s linear infinite;
        position: relative;
      }
      .SelectTimePatch::after {
        position: absolute;
        top: 2px;
        left: 2px;
        bottom: 2px;
        right: 2px;
        display: block;
        content: '';
        background-color: #3f5d46;
      }
      .EventStyle {
        border-radius: 3px;
        background: #fff;
        font-size: 12px;
        color: #333333;
        text-align: left;
        .EventTitle{
          position: relative;
          z-index: 2;
        }
        p {
          height: 100%;
          // word-break: break-all;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin: 0;
        }
        .ScteListWrap {
          width: 100%;
          height: 20px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          .ScteWrap {
            width: 100%;
            background-color: #333;
            color: #fff;
            text-align: center;
            font-size: 12px;
            position: absolute;
            p {
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            span {
              position: absolute;
              right: 10px;
              top: 0;
              i {
                color: #fff;
              }
            }
          }
          .ScteWrap::after {
            content: '';
            border-width: 5px 10px;
            border-style: solid;
            border-color: transparent rgba(255, 255, 255) transparent
              transparent;
            position: absolute;
            top: -5px;
            right: -10px;
          }
          .ScteWrap::before {
            content: '';
            border-width: 5px 10px;
            border-style: solid;
            border-color: transparent transparent transparent
              rgba(255, 255, 255);
            position: absolute;
            bottom: -5px;
            right: -20px;
          }
        }
        .ErrMessage{
          position: absolute;
          top: -36px;
          left: 0;
          background: #333333;
          padding: 8px;
          border-radius: 2px;
          z-index: 3;
          display: none;
          p{
            width: 284px;
            height: 12px;
            font-size: 12px;
            line-height: 12px;
            color: #E56464;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .ErrMessage::after{
          content: '';
          border: 6px solid transparent;
          border-top-color: #333333;
          position: absolute;
          left: 39px;
          bottom: -10px;
        }
      }
      .EventStyle:hover .ErrMessage{
        display: block;
      }
    }
  }
  .TemplateWrap::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .TemplateWrap::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    background-color: rgb(233, 233, 233);
    opacity: 0.7;
  }
  .TemplateWrap::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 5px;
    background: none;
  }
  .operation {
    display: flex;
    justify-content: flex-end;
    padding: 10px 86px 10px 0;
    .cancel {
      margin-right: 16px;
      ::v-deep .el-button--info {
        width: 100px;
        background-color: #cccccc;
        border-color: #cccccc;
        font-size: 14px;
        color: #333333;
      }
    }
    .save {
       margin-right: 16px;
      ::v-deep .el-button--success {
        width: 100px;
        background-color: #00cc66;
        border-color: #0f620a;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}
</style>
<style lang='less'>
.templatePopover{
  max-height: 200px !important;
  height: 100px;
  .title{
    display: flex;
    justify-content: space-between;
    .checkout{
      color: #FF3300;
    }
    .el-icon-close{
      cursor: pointer;
    }
  }
  .templateName{
    margin-top: 10px;
  }
}
</style>
